import React from 'react';
import { Box, Typography, TextField, Button } from '@material-ui/core';
import { isEmpty } from 'ramda';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const UpdatePasswordForm = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onSubmit, initialValues, validationSchema } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  return (
    <Box className={classes.container}>
      <Typography variant="h2" className={classes.title}>
        {t('components.UpdatePasswordForm.title')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box className={classes.formGroup}>
          <TextField
            error={touched.currentPassword && Boolean(errors.currentPassword)}
            helperText={touched.currentPassword && t(errors.currentPassword)}
            variant="outlined"
            label={t('components.UpdatePasswordForm.fields.currentPassword')}
            id="currentPassword"
            name="currentPassword"
            autoComplete="current-password"
            className={classes.field}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.currentPassword}
            type="password"
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
          <TextField
            error={touched.password && Boolean(errors.password)}
            helperText={touched.password && t(errors.password)}
            variant="outlined"
            label={t('components.UpdatePasswordForm.fields.newPassword')}
            id="password"
            name="password"
            autoComplete="new-password"
            className={classes.field}
            color="primary"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
            type="password"
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
          <TextField
            error={touched.passwordConfirmation && Boolean(errors.passwordConfirmation)}
            helperText={touched.passwordConfirmation && t(errors.passwordConfirmation)}
            variant="outlined"
            label={t('components.UpdatePasswordForm.fields.passwordConfirmation')}
            id="passwordConfirmation"
            name="passwordConfirmation"
            autoComplete="new-password"
            className={classes.field}
            color="primary"
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.passwordConfirmation}
            FormHelperTextProps={{
              style: {
                marginLeft: 0,
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            InputLabelProps={{
              shrink: false,
            }}
          />
        </Box>
        <Button variant="contained" color="primary" className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.UpdatePasswordForm.button')}
        </Button>
      </form>
    </Box>
  );
};

UpdatePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape().isRequired,
  validationSchema: PropTypes.shape().isRequired,
};

export default UpdatePasswordForm;



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/components/UpdatePasswordForm/UpdatePasswordForm.js